import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { ModalContextState } from './types';

const defaultState: ModalContextState = {
  closeModal: noop,
  openedModals: [],
  openModal: noop,
};

export const ModalContext = createContext<ModalContextState>(defaultState);
export const useModalContext = () => useContext(ModalContext);
